import { useLanguage } from "@/i18n/LanguageContext";

export default function ContactBar() {
  const { t } = useLanguage();

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-8 text-xs">
          <div className="flex items-center gap-4 md:gap-6">
            <a
              href="tel:+17863774452"
              className="flex items-center gap-1.5 hover:text-accent transition-colors"
            >
              <i className="ri-phone-line" />
              <span className="hidden sm:inline">(786) 377-4452</span>
            </a>
            <a
              href="mailto:contact@impact-window-repair-miami.com"
              className="hidden md:flex items-center gap-1.5 hover:text-accent transition-colors"
            >
              <i className="ri-mail-line" />
              contact@impact-window-repair-miami.com
            </a>
          </div>
          <div className="flex items-center gap-4">
            <span className="hidden lg:inline-flex items-center gap-1.5 text-accent">
              <i className="ri-time-line" />
              {t("contact.hours")}
            </span>
            <span className="inline-flex items-center gap-1.5 bg-white/20 px-2 py-0.5 rounded-brand">
              <i className="ri-shield-check-line" />
              {t("contact.badge")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}